/**
 * NPM Modules
 */
let logger = require('js-logger');

/**
 * Internal Modules
 */
/**
 * Module Variables
 */
const tsFormat = () => (new Date())
    .toISOString()
    .replace(/T/, ' ');
const debugLevel = logger.INFO;
/**
 * Module Functions
 */

let _init = () => {
    logger.useDefaults();
    logger.setLevel(debugLevel);
};


_init();


/**
 * Module exported Interface
 */
module.exports = logger;



// WEBPACK FOOTER //
// ./src/Modules/logger.js